import type { UserType } from '~/types/responses';

import isProd from './isProd';

/** Temporary production pilot — add `id_member` UUIDs here. Staging/non-prod: all admins see Order Edit Log. */
const ORDER_EDIT_LOGS_ALLOWED_MEMBER_IDS_PROD: ReadonlyArray<string> = [
  // Koren
  'ddd070be-9155-4aaf-8100-ff718d857ad9',
  // Sam
  '0386d4bc-43f1-4f1a-ada0-c667c3dbffe4',
  // Jayden
  'da2d0733-ac1c-4a79-8f86-e4805365acf7',
];

const allowedInProd = new Set(ORDER_EDIT_LOGS_ALLOWED_MEMBER_IDS_PROD.map((id) => id.toLowerCase()));

export function canViewOrderEditLogs(user: UserType | null | undefined): boolean {
  if (!user?.id_member) {
    return false;
  }

  if (!isProd()) {
    return true;
  }

  return allowedInProd.has(user.id_member.toLowerCase());
}
